/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/

import React from "react";
import styled from "styled-components";
import {Spinner} from "components";

const Loading = () => (
  <LoaderWrap>
    <Loader />
  </LoaderWrap>
);

const LoaderWrap = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 888;
  background-color: rgba(255, 255, 255, 0.7);
`;

const Loader = styled(Spinner)`
  position: absolute;
  left: 49vw;
  top: 49vh;
`;

export default Loading;
